export default "__VITE_ASSET__BGCco506__"